import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/tracking';
const badges = ['150 Ready-to-Teach Lessons', '7 Complete Volumes', '5 Free Bonuses', '100+ Visual Demonstrations', 'Instant Access'];
export function Hero() {
  return <section className="relative pt-8 sm:pt-12 pb-12 px-4 overflow-hidden bg-cream" data-id="element-149" data-mp="129h21r4ip6f0">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-150" data-mp="1274nzp1vrg78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-151" data-mp="xb5s7ge82vws">
          <p className="inline-block px-3 py-1 rounded-full border border-terracotta/30 bg-sand text-terracotta-deep font-semibold text-[10px] sm:text-sm tracking-[0.18em] uppercase whitespace-nowrap mb-4 sm:mb-6" data-id="element-152" data-mp="3czfny6wb6l9q">
            Art Teacher Ready
          </p>

          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6 text-charcoal" data-id="element-153" data-mp="3o6ap3tgx82yw">
            Solve an entire year of{' '}
            <span className="text-terracotta" data-id="element-154" data-mp="3e8wielksusjs">art classes</span> in just 5
            minutes.
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-[320px] sm:max-w-xl md:max-w-3xl mb-4 sm:mb-6" data-id="element-155" data-mp="30h9eq0oj2hqz">
          <img src="https://cdn.magicpatterns.com/uploads/1WQDTb3M8A2e2obw5ZX3t6/Diseno_sin_titulo_(63).png" alt="Art Teacher Ready — complete teaching library, visual classroom atlas and five bonus guides" className="relative z-10 w-full h-auto" data-id="element-156" data-mp="2hjovb94j8bdr" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="w-full" data-id="element-157" data-mp="n98djnya55nw">
          <p className="text-sm sm:text-lg md:text-xl text-charcoal-soft leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-158" data-mp="161b01fxlrg62">
            Complete teaching library with visual demonstrations,
            ready-to-teach lessons, classroom projects and five professional
            guides—ready to open, teach, and inspire today.
          </p>

          <ul className="flex flex-wrap justify-center gap-2 mb-6 sm:mb-7" data-id="element-159" data-mp="3lui8konbuvkb">
            {badges.map(badge => <li key={badge} className="bg-terracotta-deep text-paper text-[10px] sm:text-xs font-semibold uppercase tracking-wider rounded-full px-3 py-1.5" data-id="element-160" data-mp="3htg8y6pi0hht">
                {badge}
              </li>)}
          </ul>

          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-161" data-mp="268g1u1onakm3">
            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-162" data-mp="2b197qsvunyzr">
              GET THE COMPLETE TEACHING LIBRARY NOW
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-charcoal-muted" data-id="element-163" data-mp="2p10gae3lkn6d">
            <div className="flex items-center gap-1.5" data-id="element-164" data-mp="2tysf7s2nt9k2">
              <CheckCircle size={14} className="text-terracotta" aria-hidden="true" data-id="element-165" data-mp="un9bbrw7qrh9" />
              <span data-id="element-166" data-mp="znn7ocogcczg">7 complete volumes</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-167" data-mp="4acj13lsp937">
              <CheckCircle size={14} className="text-terracotta" aria-hidden="true" data-id="element-168" data-mp="3vhp43tpsu6oe" />
              <span data-id="element-169" data-mp="e88xa4a14k5j">5 strategic bonuses</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-170" data-mp="9aqme8cgbuuw">
              <CheckCircle size={14} className="text-terracotta" aria-hidden="true" data-id="element-171" data-mp="9b8m5eybor7k" />
              <span data-id="element-172" data-mp="3crphrelcf5oo">Instant access</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}